import React, { useState } from "react";
import { X, Maximize2, Minimize2 } from "lucide-react";
import useModalStore from "../../stores/modalStore";
import handbookPdf from "../../assets/Zoom_Groom_Employee_Handbook_V4.pdf";

const HandbookModal = () => {
    const show = useModalStore(state => state.showHandbookModal);
    const closeModal = useModalStore(state => state.closeModal);
    const [isFullscreen, setIsFullscreen] = useState(false);

    if (!show) return null;

    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
            <div className={`bg-white shadow-xl flex flex-col overflow-hidden transition-all duration-300 ${isFullscreen ? "w-full h-full rounded-none" : "rounded-2xl w-full max-w-5xl max-h-[95vh]"}`}>
                {/* Header */}
                <div className="flex justify-between items-center px-6 py-4 border-b border-gray-100">
                    <h2 className="text-lg font-bold text-gray-800">Employee Handbook</h2>
                    <div className="flex items-center gap-3">
                        <button
                            onClick={() => setIsFullscreen(f => !f)}
                            className="!p-1.5 !bg-transparent !border !border-gray-200 !rounded-lg hover:!bg-gray-100 !text-gray-400 hover:!text-gray-600 !transition-colors"
                            title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
                        >
                            {isFullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
                        </button>
                        <button
                            onClick={() => closeModal("handbookModal")}
                            className="!p-1.5 !bg-transparent !border !border-gray-200 !rounded-lg hover:!bg-gray-100 !text-gray-400 hover:!text-gray-600 !transition-colors"
                        >
                            <X size={16} />
                        </button>
                    </div>
                </div>

                {/* PDF Viewer */}
                <div className="flex-1 min-h-0">
                    <iframe
                        src={handbookPdf}
                        title="Employee Handbook"
                        className="w-full h-full border-none"
                        style={{ minHeight: isFullscreen ? "calc(100vh - 73px)" : "75vh" }}
                    />
                </div>
            </div>
        </div>
    );
};

export default HandbookModal;
